
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//乌克兰
export const lang ={
  Please_set_materialtype_in_product_page:"Будь ласка, перейдіть на сторінку продукту, щоб змінити та встановити тип матеріалу для кожного продукту - готові вироби - напівфабрикати - аксесуари.",
deleteAccount:"Вийти",
deleteAccountWillDeleteAllData:"Вихід із облікового запису призведе до видалення всіх даних і неможливості входу.",
backupDatabase:"резервна база даних",
restoreDatabase:"Відновити базу даних",
materialtype:"Тип матеріалу",
Manufacturing:"Виробнича версія",
Professional:"Професійна версія",
Standard:"Стандартне видання",
product:"Закінчений продукт",
halfProduct:"Напівфабрикати",
components:"Аксесуари",
Parent:"батьківський компонент",
Children:"Суб-аксесуари",
Level:"Ієрархія",
Timing:"Час",
PieceCount:"Відрядна оплата",
Wages:"Заробітна плата",
InternalProcess:"Внутрішній процес",
ExternalProcess:"зовнішній процес",
ProceName:"Назва процесу",
ProceIndex:"Порядок виконання",
ChargeMan:"головний",
BillMethod:"Спосіб виставлення рахунків",
ConsumTime:"робочі години",
Accessories:"Аксесуари",
Assembly:"Зберіть",
materials:"матеріалів",
task:"завдання",
process:"процес",
BOM:"BOM",
Production:"виробництво",
RestorePurchaseOneUse:"Відновити покупку (один користувач (обмежено попередніми покупками))",
buy_fail_try_again:"Натисніть ще раз, щоб купити",
Export:"Експорт",
Date:"дата",
BankDetail:"Банківські реквізити",
Seller:"продавець",
Buver:"покупець",
Currency:"валюта",
CompanyName:"Назва компанії",
ProformaInvoice:"рахунок-проформа",
Discount:"Знижка",
PayStatus:"Статус платежу",
ShippingStatus:"Статус доставки",
FreightType:"Вид транспорту",
Shipping:"вантажні перевезення",
Payment:"Оплата",
Moneyname:"назва валюти",
Tax:"податки",
Freight:"Транспортні витрати",
Insurance:"страхування",
Bankfee:"банківські комісії",
Qc:"Сертифікат якості",
Exchangerate:"курс валюти",
Shippingnumber:"номер відправлення",
ShipDate:"Дата відвантаження",
Arrivedate:"Дата прибуття",
Grossweight:"вага брутто",
CubicWeight:"кубічної ваги",
Totalpackages:"Загальна кількість упаковок",
Moneytype:"тип валюти",
Quotedate:"дата цитати",
Validitydate:"Дійсна дата",
Paymentterm:"закінчення терміну виплати заробітної плати",
Priceterm:"термін ціноутворення",
DeliveryTerm:"Час доставки",
BankName:"назва банку",
BankAddress:"адреса банку",
SwiftCode:"Код банку",
Review:"огляд",
Signfor:"Підпишіть про отримання",
Finance:"фінанси",
Receiver:"Приймач",
Business:"бізнес",
ContactPerson:"Контактна особа",
Profit:"прибуток",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Співробітники повинні використовувати Google Chrome. Будь ласка, перевірте IP-адресу на сторінці довідки основного сервісного комп’ютерного APP, а потім введіть адресу в стовпці URL інших комп’ютерних браузерів, щоб відкрити вхід",
newPassword:"Новий пароль",
ForgetPassword:"забути пароль",
ContactUs:"Зв'яжіться з нами/внесіть пропозиції",
Actualpay_should_big_then_shouldpay:"Фактичні надходження не можуть перевищувати дебіторську заборгованість",
ShopAddress:"Адреса мого магазину. Щоб зробити замовлення, відскануйте QR-код",
Submit:"подати",
All:"все",
OrdernumExists:"Номер замовлення вже існує",
PermissionDenied:"у дозволі відмовлено",
StockTransfer:"Передача запасів",
FromWarehouse:"Передача зі складу",
ToWarehouse:"Передача на склад",
PleaseUseInWebBrowser:"Скористайтеся функцією експорту Excel у Google Chrome",
PleasePrintInWebBrowser:"Скористайтеся функцією друку в Google Chrome",
HistoryPrice:"історична ціна",
SerialNumber:"серійний номер",
Please_Use_In_APP:"Будь ласка, використовуйте його в комп’ютерному програмному забезпеченні",
Please_Purchase_In_APP:"Купуйте в ДОДАТКУ, а не в браузері",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Ви можете підключитися до бази даних Postgresql. Ваші дані зберігатимуться в базі даних Postgresql. За замовчуванням вам не потрібно підключатися до бази даних Postgresql. За замовчуванням це локальна база даних Sqlite.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Підключіться до бази даних Postgresql, ваші дані будуть збережені в базі даних Postgresql, і дані будуть прочитані знову",
Use_sqlite_data_will_store_in_local:"За допомогою sqlite дані зберігатимуться на локальній машині",
UsePostgresqlDatabase:"Використання бази даних PGSQL",
UseSqliteDatabase:"Використання бази даних Sqlite",
DatabaseName:"База імен",
Test_connect:"тестове підключення",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Якщо товар має колір або розмір, для початкового асортименту введіть 0. Після додавання товару внесіть асортимент у покупку.",
my:"Шахта",
my_shop_qrcode_scan:"QR-код мого магазину надає клієнтам можливість сканувати код, щоб розмістити замовлення. Мобільний телефон клієнта має бути підключений до того самого маршрутизатора, що й ваш комп’ютер.",
ip:"IP",
port:"Порт",
orderstatus:"Статус замовлення",
image:"картина",
Template:"шаблон",
Please_select_a_excel_file:"Виберіть файл",
Please_select_only_one_excel_file:"Можна вибрати лише один файл",
Connect_Internet_Login_again:"Перед покупкою підключіться до Інтернету та увійдіть знову",

    productHasValidDate:'Продукт має дійсний період',
productHasColor:'Продукт має колірний розмір',
GeneralGoods:'Загальні товари',
Selected:'Вибрано',
RestorePurchase:'Відновити покупку',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Купити Виставлення рахунків Enterprise Edition 1 користувачів постійно',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Покупка виставлення рахунків Enterprise Edition необмежена для користувачів і пристроїв',
Purchasing:'Покупка ... Почекайте ...',
Validdate:'Термін дії',
Makedate:'Дата виробництва',
Batch:'Пакетна',
CheckVersion:'Перевірити версію',
Please_set_this_ip_address_on_App:'Установіть цей IP-адресу або IP-адресу комп’ютера на APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Відкрийте це з’єднання у своєму комп’ютері або мобільному веб-переглядачі (підключіть той самий WiFi)',


    CheckVersion: "Перевірити версію",
You_need_to_purchase: 'Ви ще не придбали, додайте WeChat до Elink9988 Електронна пошта: bvbuy@qq.com',
Thank_for_your_purchase: "Ви вже придбали",
New_version_available: "Є нова версія",
Is_the_latest_version: "це остання версія",
    please:'будь ласка',
input:'введення',
wrong:'неправильно',
Verifycode:'Перевірте код',
Upload:'Завантажити',
Download:'Завантажити',
You_need_to_purchase_to_continue_use:'Щоб продовжити використання, потрібно придбати',
CheckBuy:'Перевірити покупку',
Exists:'Існує',
NetworkUnavailable:'Мережа недоступна',
Today:'Сьогодні',
Yesterday:'Вчора',
ThisMonth:'Цього місяця',
LastMonth:'Останній місяць',
nickname:'псевдонім',
storeName:'Ім‘я магазину',
BuyStandAlone:'купити автономну версію',
PermissionDenied:'Дозволи заборонено',
Boss:'Бос',

    login:'Вхід',
    operate:'Робота',
    register:'Реєстрація',
    username:'Ім\'я користувача',
    password:'Пароль',
    User:'Користувач',
    ok:'в порядку',
    back:'Назад',
    success:'Успіх',
    fail:'Fail',
    cancel:'скасувати',
    add:'Додати',
    edit:'редагувати',
    delete:'Видалити',
    refresh:'Оновити',
    close:'Закрити',
    cancel:'Скасувати',
    return:'Повернення',
    ElinkInvoice:'Рахунок Elink',
    Purchase:'Придбати',
    BaseData:'Базові дані',
    Sell:'Продам',
    PurchaseReturns:'Прибуток повертається',
    SellReturns:'Продаж повертається',
    Inventory:'Інвентаризація',
    Statistics:'Статистика',
    Receivable:'Дебіторська заборгованість',
    Payable:'До оплати',
    Orders:'Замовлення',
    StockTransfer:'Передача запасу',
    StockRecall:'Нагадаємо про запас',
    Customer:'Клієнт',
    Supplier:'Постачальник',
    Warehouse:'Склад',
    Color:'Колір',
    Size:'Розмір',
    Category:'Категорія',
    Category2:'Категорія2',
    Product:'Продукт',
    Account:'Рахунок',
    AccountType:'Категорія облікового запису',
    Staff:'Персонал',
    typeone:'Категорія',
    typetwo:'Підкатегорія',
    ProductName:'Назва продукту',
    Specification:'Специфікація',
    Barcode:'Штрих-код',
    Buyprice:'Купити ціну',
    Sellprice:'Ціна продажу',
    Wholesaleprice:'Оптова ціна',
    Currentstock:'Струми тока',
    Unit:'Блок',
    Initstock:'Init stock',
    Parameter:'Параметр',
    Remark:'Примітка',
    Supplier:'Постачальник',
    Customer:'Клієнт',
    Staff:'Персонал',
    Receivable:'Дебіторська заборгованість',
    payable:'сплачується',
    Receipts:'Надходження',
    Paid:'Платні',
    Preferential:'Переважно',
    DateDay:'Дата',
    OrderNum:'Номер замовлення',
    Name:'Ім\'я',
    UserName:'Ім\'я користувача',
    IdNum:'Номер документа',
    BirthDay:'День народження',
    SEX:'Секс',
    Female:'Жінка',
    Male:'Чоловічий',
    Select:'Виберіть',
    Address:'Адреса',
    Phone:'Телефон',
    Email:'Електронна пошта',
    CardNum:'Номер картки',
    Price:'Ціна',
    QTY:'Кількість',
    SupplierCategory:'Категорія постачальників',
    CustomerCategory:'Категорія клієнта',
    Power:'Потужність',
    Role:'Роль',
    save:'Зберегти',
    image:'зображення',
    search:'Пошук',
    Year:'Рік',
    Month:'Місяць',
    Day:'День',
    Total:'Усього',
    WorkReport:'Звіт про роботу',
    Leave:'Залишати',
    CheckIn:'Перевірь',
    Announcement:'Оголошення',
    Approval:'Схвалення',
    Tracking:'Відстеження',
    Bill:'Білл',
    OrdersDetail:'Деталі замовлень',
    Expense:'Витрати',
    Income:'Дохід',
    Userfor:'Користувач для',
    Amount:'Сума',
    Title:'Назва',
    News:'Новини',
    SelectFile:'Виберіть файл',
    Content:'Вміст',
    Cost:'Вартість',
    ApprovalUser:'Затвердження користувача',
    ApprovalStatus:'Статус затвердження',
    ApprovalRemark:'Зауваження затвердження',
    ApprovalDate:'Дата затвердження',
    SubmitDate:'Дата подання',
    Status:'Статус',
    FromDateTime:'Час від дати',
    ToDateTime:'Час до дати',
    Subject:'Тема',
    Latitude:'Широта',
    Longitude:'Довгота',
    Print:'Друк',
    DataTrans:'Data Trans',
    OA:'О.А.',
    Setting:'Набір',
    Help:'Довідка',
    ScanOpenInPhone:'Сканування відкрито в телефоні',
    Building:'Будівництво',
    Room:'Номер',
    HotelCheckIn:'Перевірь',
    CheckOut:'Перевіряти',
    Hotel:'Готель',
    Checkintime:'Перевірте час',
    Checkouttime:'Перевірте час',
    Deposit:'Депозит',
    Cost:'Вартість',
    RoomNum:'Номер Номер',
    Rent:'Оренда',
    costday:'costday',
    rent:'оренда',
    waternum:'Ступінь води',
    electricnum:'Електрична ступінь',
    gasnum:'Ступінь газу',
    watercost:'вартість води',
    electriccost:'електричні витрати',
    gascost:'вартість газу',
    cleaningcost:'вартість прибирання',
    networkcost:'вартість мережі',
    tvcost:'вартість ТБ',
    managecost:'управління витратами',
    othercost:'інші витрати',
    totalcost:'Загальна вартість',
    remark:'зауваження',
    addtime:'додайте час',
    OpenInBrowser:'Відкрити в браузері',
    InventoryProfit:'Інвентарний прибуток',
    InventoryLoss:'Втрата запасів',
    Buy:'Купити',



Refresh:'Оновити',
Add:'Додати',
Search:'Пошук',
Records:'записів',
}



// WEBPACK FOOTER //
// ./src/lang/uk.js